import { create } from 'zustand';
import { FileUtils } from '@shared/utils';
import { AccountApi, ApiUtils, RequestStrategyEnum } from '@shared/api';

interface UseUploadedCreditPdfStore {
  loading: boolean;
  error: string | null;
  getUploadedCreditPdf: (request: { requestId: string; filename: string }, signal?: AbortSignal) => Promise<void>;
  clear: () => void;
}

export const useUploadedCreditPdfStore = create<UseUploadedCreditPdfStore>((set) => ({
  loading: false,
  error: null,

  getUploadedCreditPdf: ApiUtils.wrapperApi(async (request, signal) => {
    try {
      set({ loading: true, error: null });
      const result = await AccountApi.getUploadedCreditPdf(request.requestId, signal);
      FileUtils.downloadFile(result, request.filename);
      set({ loading: false });
    } catch (error) {
      set({ loading: false, error: ApiUtils.getApiError(error) });
    }
  }, RequestStrategyEnum.Debounce),

  clear: () => set({ loading: false, error: null }),
}));
